"use client";

import { c as _c } from "react/compiler-runtime";
import type { CicStatement } from "@/entities/IProfile";
import UserPageIdentityStatementsStatement from "./UserPageIdentityStatementsStatement";
import { useContext, useEffect, useState } from "react";
import { amIUser } from "@/helpers/Helpers";
import CommonSkeletonLoader from "@/components/utils/animation/CommonSkeletonLoader";
import { AuthContext } from "@/components/auth/Auth";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageIdentityStatementsStatementsList(t0) {
  const $ = _c(28);
  const {
    statements,
    profile,
    noItemsMessage,
    loading
  } = t0;
  const {
    address
  } = useSeizeConnectContext();
  const {
    activeProfileProxy
  } = useContext(AuthContext);
  const [isMyProfile, setIsMyProfile] = useState(false);
  let t1;
  let t2;
  if ($[0] !== address || $[1] !== profile) {
    t1 = () => setIsMyProfile(amIUser({
      profile,
      address
    }));
    t2 = [profile, address];
    $[0] = address;
    $[1] = profile;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== activeProfileProxy || $[5] !== isMyProfile) {
    t3 = () => isMyProfile && !activeProfileProxy;
    $[4] = activeProfileProxy;
    $[5] = isMyProfile;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const getCanEdit = t3;
  let t4;
  if ($[7] !== getCanEdit) {
    t4 = getCanEdit();
    $[7] = getCanEdit;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const [canEdit, setCanEdit] = useState(t4);
  let t5;
  if ($[9] !== getCanEdit) {
    t5 = () => setCanEdit(getCanEdit());
    $[9] = getCanEdit;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== activeProfileProxy || $[12] !== isMyProfile) {
    t6 = [isMyProfile, activeProfileProxy];
    $[11] = activeProfileProxy;
    $[12] = isMyProfile;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t5, t6);
  if (loading) {
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div className="tw-pt-2"><CommonSkeletonLoader /></div>;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    return t7;
  }
  let t7;
  if ($[15] !== canEdit || $[16] !== profile || $[17] !== statements) {
    let t8;
    if ($[19] !== canEdit || $[20] !== profile) {
      t8 = statement => <UserPageIdentityStatementsStatement key={statement.id} statement={statement} profile={profile} canEdit={canEdit} />;
      $[19] = canEdit;
      $[20] = profile;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    t7 = statements.map(t8);
    $[15] = canEdit;
    $[16] = profile;
    $[17] = statements;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[22] !== noItemsMessage || $[23] !== statements.length) {
    t8 = !statements.length && <span className="tw-text-xs tw-font-normal tw-text-iron-500">{noItemsMessage}</span>;
    $[22] = noItemsMessage;
    $[23] = statements.length;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t7 || $[26] !== t8) {
    t9 = <ul className="tw-mb-0 tw-mt-2 tw-list-none tw-space-y-0 tw-inline-flex tw-flex-col tw-w-full tw-pl-0 tw-text-base tw-text-iron-300">{t7}{t8}</ul>;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}